import React, { FC } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { Container } from 'src/components'
import Column from './Column'

interface Props {
  title: string
  subTitle: string
  includedLabel: string
  optionals: Array<string>
}

const VehicleOptionals: FC<Props> = ({
  title,
  subTitle,
  includedLabel,
  optionals
}) => (
  <Box bg="baseNeutral.100" paddingY={{ base: 'xxl', sm: 'xxl', md: 'xxl6' }}>
    <Container paddingY="0">
      <Box padding="m" pt="0">
        <Text
          as="h2"
          fontFamily="Montserrat-SemiBold"
          fontSize={{ base: '1.25rem', md: '1.5rem' }}
          lineHeight="31px"
          letterSpacing={{ base: '0.58px', md: '0.68px' }}
          textAlign="center"
          color="baseDark"
        >
          {title}
        </Text>
      </Box>

      <Column
        title={subTitle}
        items={optionals}
        includedLabel={includedLabel}
      />
    </Container>
  </Box>
)

export default VehicleOptionals
